import { Link } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin, Clock } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-graphite text-cream/90 py-16 md:py-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-cream rounded-full flex items-center justify-center">
                <span className="text-graphite font-heading text-lg">S</span>
              </div>
              <span className="font-heading text-2xl text-cream">Studio</span>
            </div>
            <p className="font-body text-cream/80 text-sm leading-relaxed mb-6">
              Experiencia premium en cuidado personal. Reserva tu cita y descubre la diferencia.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-cream/30 flex items-center justify-center hover:bg-cream/10 transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-cream/30 flex items-center justify-center hover:bg-cream/10 transition-colors"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg mb-4">Enlaces</h4>
            <ul className="space-y-3">
              {['Servicios', 'Agenda', 'Galeria', 'Promos'].map((item) => (
                <li key={item}>
                  <Link
                    to={`/${item.toLowerCase()}`}
                    className="font-body text-sm text-cream/75 hover:text-cream transition-colors"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg mb-4">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-copper mt-0.5" />
                <div>
                  <p className="font-body text-sm text-cream/85">+52 81 1234 5678</p>
                  <p className="font-body text-xs text-cream/60">WhatsApp disponible</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-copper mt-0.5" />
                <p className="font-body text-sm text-cream/85">hola@studio.mx</p>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-copper mt-0.5" />
                <p className="font-body text-sm text-cream/70">3 sucursales en MTY</p>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-heading text-lg mb-4">Horario</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <Clock className="w-5 h-5 text-copper" />
                <div>
                  <p className="font-body text-sm text-cream/85">Lun - Sab</p>
                  <p className="font-body text-xs text-cream/60">9:00 - 20:00</p>
                </div>
              </li>
              <li className="pl-8">
                <p className="font-body text-sm text-cream/85">Domingo</p>
                <p className="font-body text-xs text-cream/60">10:00 - 16:00</p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-cream/10">
          <div className="flex flex-col md:flex-row md:items-center gap-4">
            <p className="font-body text-xs text-cream/55">
              Ac {currentYear} Studio. Todos los derechos reservados.
            </p>
            <div className="flex flex-wrap items-center gap-6 md:ml-auto">
              <a href="#" className="font-body text-xs text-cream/55 hover:text-cream/80 transition-colors">
                Politica de Privacidad
              </a>
              <a href="#" className="font-body text-xs text-cream/55 hover:text-cream/80 transition-colors">
                Terminos de Servicio
              </a>
              <a href="#" className="font-body text-xs text-cream/55 hover:text-cream/80 transition-colors">
                Cancelaciones
              </a>
              <span className="font-body text-xs text-cream/70">
                Desing by Culto
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
